module.exports = __webpack_public_path__ + "img/video.ca831eb8.png";